import * as React from 'react';
import { NavLink } from 'react-router-dom';
import {
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { UserView } from 'cb-model';
import { QueryOptions } from 'gossamer-unified';

export const UserSearch = (): React.JSX.Element => {
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(UserView, {
    where: {
      and: [{ fieldId: 'email', operator: 'ct', value: '' }],
    },
    order: [['last_name', 'ASC']],
  } as QueryOptions);

  const gCacheQueryItem = useCacheQuery(UserView, queryOptions);
  return (
    <>
      <PageTitle verb="Search" entity={UserView} />
      <Section>
        <PaginatorAndListSettings
          entity={UserView}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
      <Section>
        <NavLink
          to={
            '?q=' +
            encodeURIComponent(
              JSON.stringify({
                where: {
                  and: [
                    { fieldId: 'email', operator: 'ct', value: '' },
                    { fieldId: 'unsuccessful_login_attempts', operator: 'gt', value: 4 },
                  ],
                },
                order: [['last_name', 'ASC']],
                limit: 20,
                offset: 0,
              }),
            )
          }
        >
          Locked-out Accounts
        </NavLink>
      </Section>
    </>
  );
};
